import { render, staticRenderFns } from "./ImageTopicsComponent.vue?vue&type=template&id=e08239d0&"
import script from "./ImageTopicsComponent.vue?vue&type=script&lang=js&"
export * from "./ImageTopicsComponent.vue?vue&type=script&lang=js&"
import style0 from "./ImageTopicsComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports